<script>
export default {
  name: 'TrashIcon',
};
</script>

<template>
  <path
    d="M4.32262 1.17402L4.11905 1.58366H1.40476C0.904315 1.58366 0.5 1.99329 0.5 2.50033C0.5 3.00736 0.904315 3.41699 1.40476 3.41699H12.2619C12.7624 3.41699 13.1667 3.00736 13.1667 2.50033C13.1667 1.99329 12.7624 1.58366 12.2619 1.58366H9.54762L9.34405 1.17402C9.19137 0.861784 8.87753 0.666992 8.53542 0.666992H5.13125C4.78914 0.666992 4.4753 0.861784 4.32262 1.17402ZM12.2619 4.33366H1.40476L2.00417 14.0446C2.0494 14.7693 2.64315 15.3337 3.35848 15.3337H10.3082C11.0235 15.3337 11.6173 14.7693 11.6625 14.0446L12.2619 4.33366Z"
  />
</template>
